import 'babel-polyfill'
import 'weakmap-polyfill';
import 'core-js/es/set'
import 'core-js/es/map'
import Vue from 'vue';
import VueGtag from "vue-gtag";
import VueI18n from 'vue-i18n';
import VueCookie from 'vue-cookie';
import IdleVue from 'idle-vue'
import App from './App.vue';
import router from './config/Router';
import store from './config/Store';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { defaultLocale, languages } from './languages/index';

Vue.config.productionTip = false;

export const eventBus = new Vue();

Vue.use(VueCookie);
Vue.use(VueI18n);

Vue.use(IdleVue, {
  eventEmitter: eventBus,
  idleTime: 120000
})

Vue.use(VueGtag, {
  config: { id: "G-GED2K3K2LW" }
});

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: Object.assign(languages)
});

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new VueIntegration({Vue, attachProps: true})]
});

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
